/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_NameInputs */

const en_guest_book_name = /** @type {(inputs: Guest_Book_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

const pl_guest_book_name = /** @type {(inputs: Guest_Book_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imię i nazwisko`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Guest_Book_NameInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_name = /** @type {((inputs?: Guest_Book_NameInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_NameInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_name(inputs)
	return en_guest_book_name(inputs)
});